import { Item } from '@react-stately/collections'
import { Button } from 'blaze-ui/Button'
import { WeekDay, WeekDays } from 'types'
import {
  ONLY_WEEK_DAYS,
  ONLY_WEEKENDS,
  WEEK_DAYS,
} from 'screens/VirtualMarketerOnboarding/CustomizeSchedule/CustomizeSchedule'
import { useMemo } from 'react'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { Menu } from 'components/Menu/Menu'

interface DaysDropdownProps {
  weekDays: WeekDays
  onChange: (days: WeekDays) => void
  isDisabled?: boolean
}

export const DaysDropdown = ({ weekDays, onChange, isDisabled }: DaysDropdownProps) => {
  const label = useMemo(() => {
    if (weekDays.length < 1) return 'Select days'
    if (weekDays.length === 1) return weekDays[0].substring(0, 3)
    if (weekDays.length === WEEK_DAYS.length) return 'Every day'
    if (weekDays.length === ONLY_WEEK_DAYS.length && ONLY_WEEK_DAYS.every((d) => weekDays.includes(d)))
      return 'Weekdays'
    if (weekDays.length === ONLY_WEEKENDS.length && ONLY_WEEKENDS.every((d) => weekDays.includes(d))) return 'Weekends'
    return weekDays.map((d) => d.substring(0, 1)).join(', ')
  }, [weekDays])

  return (
    <DropdownTrigger placement="bottom-end">
      <Button variant="secondary" withChevron="down" isDisabled={isDisabled} aria-label="Select days to post">
        {label}
      </Button>
      <Menu
        onAction={(key) => {
          const next = new Set(weekDays)
          if (next.has(key as WeekDay)) next.delete(key as WeekDay)
          else next.add(key as WeekDay)
          const sorted = [...next].sort((a, b) => WEEK_DAYS.indexOf(a) - WEEK_DAYS.indexOf(b))
          if (sorted.length > 0) onChange(sorted)
        }}
        selectionMode="multiple"
        selectedKeys={weekDays}
        showCheckmark
        aria-label="Days to post"
      >
        {WEEK_DAYS.map((day) => (
          <Item key={day} textValue={day}>
            {day}
          </Item>
        ))}
      </Menu>
    </DropdownTrigger>
  )
}
